// eslint-disable-next-line import/no-cycle
import router from '@/router';
import { AuthErrors } from '@/shared/models/auth-errors.model';
import { AuthLocalStorageKeys } from '@/shared/models/auth-localstorage-keys';
import { AxiosRequestConfig } from 'axios';
import { applyBearerOrCookie, effectiveAuthorizationHeader } from './auth-strategy';

// eslint-disable-next-line import/prefer-default-export
export class AuthenticationService {
  static setAuthenticationToken(token: any) {
    const authorizationHeader = effectiveAuthorizationHeader(token);
    if (!authorizationHeader) {
      return sessionStorage.removeItem(AuthLocalStorageKeys.TOKEN);
    }
    return sessionStorage.setItem(AuthLocalStorageKeys.TOKEN, authorizationHeader);
  }

  static hasPermission() {
    return !!this.getAuthToken();
  }

  static getAuthToken() {
    return sessionStorage.getItem(AuthLocalStorageKeys.TOKEN);
  }

  static async requestTokenInterceptor(config: AxiosRequestConfig) {
    return applyBearerOrCookie(config, AuthenticationService.getAuthToken());
  }

  static async errorResponseInterceptor(error: any) {
    if (!error.response) {
      return Promise.reject(error);
    }

    const { status } = error.response;

    if (status === AuthErrors.UNAUTHORIZED || status === AuthErrors.FORBIDDEN) {
      return router.push('/');
    }

    return Promise.reject(error.response);
  }
}
